// 机经题库列表父类列表

import request from '@/utils/http'
import { defineStore } from 'pinia'
import { onMounted, ref } from 'vue'

export interface WordsColor {
  id: number
  start: number
  end: number
  color: string
  status: number
}
export const useWordsColor = defineStore(
  'wordsColor',
  () => {
    const wordsColor = ref<WordsColor[]>([
      { id: 9, start: 85, end: 100, color: '#17b017', status: 2 },
      { id: 8, start: 70, end: 85, color: '#414a4e', status: 1 },
      { id: 7, start: 0, end: 70, color: '#e43f3f', status: 0 }
    ])
    const getColor = () => {
      if (wordsColor.value.length <= 0) {
        request.get<WordsColor[]>('/api/voice/getColor').then((res) => {
          wordsColor.value = res.data.sort((a, b) => b.start - a.start)
        })
      }
    }

    const scoreToColor = (score_decimals: number) => {
      const score = score_decimals * 18
      let color = ''

      wordsColor.value
        .sort((a, b) => a.start - b.start)
        .forEach((item) => {
          if (score >= item.start) {
            color = item.color
          }
        })

      return color
    }
    onMounted(() => {
      getColor()
    })
    return {
      wordsColor,
      scoreToColor
    }
  },
  {
    persist: {
      storage: sessionStorage,
      paths: ['wordsColor']
    }
  }
)
